"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeScreen = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const getComponent_1 = require("../../getComponent");
const ComponentState = (0, getComponent_1.getComponent)('ComponentState');
/**
 * # 🏠 HomeScreen
 *
 * ## Usage
 * ```jsx
 * <HomeScreen/>
 * ```
 */
const HomeScreen = (props) => (<ComponentState title="BlueBase" description="Welcome to BlueBase Framework!" imageSource="LogoSquare" styles={{ image: { width: 100, height: 100 } }} {...props}/>);
exports.HomeScreen = HomeScreen;
exports.HomeScreen.displayName = 'HomeScreen';
